/* eslint-disable max-len */
import {
    Box, Stack, TabPanel, Text, VStack,
} from '@chakra-ui/react';
import { ThemeTokens } from '@acp/core-ui';
import { faInfoCircle } from '@fortawesome/sharp-light-svg-icons';
import { CardLayout } from '../../card-layout';
import { NonManagedPortfolioGraph } from './non-managed-portfolio-graph';
import { ComplianceSummaryGraph } from './compliance-summary-graph';
import { NonManagedPortfolioPopoverContent } from './non-managed-portfolio-popover-content';
import { ComplianceSummaryPopoverContent } from './compliance-summary-popover-content';

export function NonManagedGraphsTab() {
    return (
        <TabPanel as={VStack} alignItems="stretch" p={0} pt={2} gap={4}>
            <Text>
                Compliance summary of properties managed by other service providers.
            </Text>
            <VStack alignItems="center" justifyContent="center" gap={4}>
                <CardLayout px={0} py={0}>
                    <Stack
                        direction={{ base: 'column', lg: 'row' }}
                        w="full"
                        gap={{ base: 4, md: 8, lg: 4 }}
                        justifyContent="space-between"
                        alignItems="stretch"
                        flexWrap={{ base: 'wrap', lg: 'nowrap' }}
                    >
                        {/* Portfolio */}
                        <Box
                            shadow="sm"
                            borderWidth={1}
                            borderColor={ThemeTokens.Defaults.borderColor}
                            borderRadius="md"
                            w="full"
                            overflow="hidden"
                        >
                            <CardLayout>
                                <CardLayout.Title>
                                    <CardLayout.Title.Heading
                                        heading="Portfolio"
                                        position="relative"
                                    />
                                    <CardLayout.Title.Popover popoverIcon={faInfoCircle}>
                                        <NonManagedPortfolioPopoverContent />
                                    </CardLayout.Title.Popover>
                                </CardLayout.Title>
                                <CardLayout.Body>
                                    <NonManagedPortfolioGraph />
                                </CardLayout.Body>
                            </CardLayout>
                        </Box>

                        {/* Compliance summary */}
                        <Box
                            shadow="sm"
                            borderWidth={1}
                            borderColor={ThemeTokens.Defaults.borderColor}
                            borderRadius="md"
                            w="full"
                            overflow="hidden"
                        >
                            <CardLayout>
                                <CardLayout.Title>
                                    <CardLayout.Title.Heading
                                        heading="Compliance summary"
                                    />
                                    <CardLayout.Title.Popover popoverIcon={faInfoCircle}>
                                        <ComplianceSummaryPopoverContent />
                                    </CardLayout.Title.Popover>
                                </CardLayout.Title>
                                <CardLayout.Body>
                                    <ComplianceSummaryGraph />
                                </CardLayout.Body>
                            </CardLayout>
                        </Box>
                    </Stack>
                </CardLayout>
            </VStack>
        </TabPanel>
    );
}
